import React from 'react';
import './GoogleMaps.css';
import FadeIn from 'react-fade-in';

//////
//TODO:
//Move API key grab from file to backend
/////

export class GoogleMaps extends React.Component{
constructor(props){
  super(props);


  this.state={
    API: "AIzaSyAIFsjII2JeMXLPI-dQYc99cerhfN8igUw",
    GoogleSpot: "Eidsberg+middle+school",

    showMap: false
  };

  //Bindings
  this.ReadAPI = this.ReadAPI.bind(this);
  this.CloseMap = this.CloseMap.bind(this);
  this.OpenMap = this.OpenMap.bind(this);
}



//Newprops explanation: https://stackoverflow.com/questions/33884990/react-component-only-changes-state-on-second-onclick-event/33885181
componentWillReceiveProps(newProps) //Will recieve props from whatever is passing the showMap props
{
  if(newProps.showMap === true)
  {
    this.setState({showMap: true});
  }
  else if(newProps.showMap === false)
  {
    this.setState({showMap: false});
  }
}


ReadAPI(API, spot)
{
  //Here we will get APIkey from backend when implemented
  //AIzaSyAIFsjII2JeMXLPI-dQYc99cerhfN8igUw
  
  return('https://www.google.com/maps/embed/v1/place?key=' + API + '&q=' + spot); //Manual return for now
}

CloseMap(e){
  this.setState({showMap: false});
  this.props.handleShowMap();
}

OpenMap(e){
  this.setState({showMap: true});
}


  

render()
{
  return(
    <FadeIn>
    <div>
    {this.state.showMap === true && 
    <div className="map">
    
    <iframe title="veibeskrivelse" style={{width:"100%", height:"100%", frameborder:"0", border:"0"}} 
    src={this.ReadAPI(this.state.API, this.state.GoogleSpot)} allowFullScreen>
    </iframe>
    <button className="mapButton btn btno btn-danger" onClick={this.CloseMap}>Lukk</button>
    </div>
    }

    
    </div>
    </FadeIn>
  )
}



}
export default GoogleMaps;


// WEBPACK FOOTER //
// ./src/Components/GoogleMaps/GoogleMaps.js